import { render, staticRenderFns } from "./AddComponents.vue?vue&type=template&id=3a33c6b8&scoped=true"
import script from "./AddComponents.vue?vue&type=script&lang=js"
export * from "./AddComponents.vue?vue&type=script&lang=js"
import style0 from "./AddComponents.vue?vue&type=style&index=0&id=3a33c6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33c6b8",
  null
  
)

export default component.exports